export default "__VITE_ASSET__amTq6SXM__";